import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router";
import { ArrowLeft } from "lucide-react";
import { get, ref } from "firebase/database";

import DriverForm from "../forms/DriverForm";
import { database } from "../../firebase/firebase";
import { Button } from "../../components/ui/button";

export default function EditDriverPage() {
  const [data, setData] = useState<any>();
  const [key, setKey] = useState<string | null>(null);

  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (id) {
      get(ref(database, `drivers/${id}`)).then((snapshot: any) => {
        if (snapshot.exists()) {
          setData(snapshot.val());
          setKey(snapshot.key);
        } else {
          navigate("/admin-management");
        }
      });
    }
  }, [id, navigate]);

  const goBack = () => navigate("/admin-management/others/drivers");

  return (
    <div className="min-h-screen bg-slate-950 px-4 py-6 text-white">
      <header className="mb-6 flex items-center gap-3">
        <Button
          variant="ghost"
          size="icon"
          className="text-white hover:bg-white/10"
          onClick={goBack}
        >
          <ArrowLeft className="h-5 w-5" />
        </Button>
        <div>
          <p className="text-xs uppercase tracking-[0.4em] text-white/60">
            Motorista
          </p>
          <h1 className="text-2xl font-semibold">Editar motorista</h1>
        </div>
      </header>
      <DriverForm id={key || undefined} driver={data} />
    </div>
  );
}
